import type {
  DraftJob,
  GetBrandQuery,
  GetSuggestedCategoriesQuery,
  HirerAccount,
  Location,
} from 'src/graphql/generated';

type TranslatedLabels = {
  urgentHiringLabel: string;
};

type FunctionParams = {
  draft?: DraftJob | null;
  location?: Location | null;
  categories?: GetSuggestedCategoriesQuery['suggestedCategories'] | null;
  brand?: GetBrandQuery['brand'] | null;
  hirerAccount?: HirerAccount | null;
  isJobFeatured?: boolean;
  isBrandingEnabled?: boolean;
  isKeySellingPointsEnabled?: boolean;
  isUrgentHiringEnabled?: boolean;
  translatedLabels: TranslatedLabels;
};

export const getSerpDetailsForPreview = ({
  categories,
  hirerAccount,
  draft,
  isBrandingEnabled = false,
  isJobFeatured = false,
  isKeySellingPointsEnabled = false,
  isUrgentHiringEnabled = false,
  translatedLabels,
  location,
  brand,
}: FunctionParams) => {
  const { urgentHiringLabel } = translatedLabels;
  const suggestedCategory = categories?.find(
    (c) =>
      String(c.category.subCategoryId) === draft?.categories?.[0].subCategoryId,
  );

  return {
    advertiserName: hirerAccount?.businessName,
    bullets: draft?.keySellingPoints || [],
    category: suggestedCategory?.category.categoryName,
    displayPay: !draft?.salary?.isHidden,
    isFeatured: isJobFeatured,
    jobTitle: draft?.titles?.[0]?.title,
    location: location?.displayDescription,
    ...(isBrandingEnabled && { logo: brand?.assets.logo }),
    salaryText: draft?.salary?.displayValue,
    salaryCurrency: draft?.salary?.currency,
    searchDescription: draft?.summary,
    showBullets:
      draft?.keySellingPoints && isKeySellingPointsEnabled
        ? draft.keySellingPoints.length > 0
        : false,
    subcategory: suggestedCategory?.category.subCategoryName,
    tags: isUrgentHiringEnabled
      ? [{ type: 'URGENT', label: urgentHiringLabel }]
      : [],
  };
};
